import { connect } from 'react-redux';
import { songsLibrary } from 'services/store/user/actions';
import { UserStore } from 'services/store/user';
import { TagStore } from 'services/store/tags';
import SongListItem from './SongListItem';

const mapStateToProps = ({
  user,
  tags,
}: {
  user: UserStore;
  tags: TagStore;
}) => ({
  tagStore: tags,
  page: user.songsLibrary.page,
  variant: 'library',
});

// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  getSongs: (params: {
    page: number;
    unifiedLibraryStructure?: boolean;
  }): void => {
    const { page, unifiedLibraryStructure } = params;

    dispatch(
      songsLibrary({
        page,
        unifiedLibraryStructure: unifiedLibraryStructure ?? true,
      })
    );
  },
});

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(SongListItem);
